// Centralize auth cookie options to avoid path/domain mismatches.
export const getAccessTokenCookieOptions = (extra?: Record<string, any>) => {
  const options: Record<string, any> = { path: '/' };
  const host = window.location.hostname;

  if (host === 'zynity.com' || host.endsWith('.zynity.com')) {
    options.domain = '.zynity.com';
  }

  return { ...options, ...(extra || {}) };
};
